import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-accordion',
  templateUrl: './accordion.component.html',
  standalone: false,
})
export class AccordionComponent {
  @Input() open = false;

  toggle() {
    this.open = !this.open;
  }
}
